/**
 * Accessibility: honor prefers-reduced-motion for media that the theme
 * cannot conditionally render server-side (notably <video autoplay>).
 *
 * Covers WCAG 2.2.2 (Pause, Stop, Hide) and 2.3.3 (Animation from
 * Interactions) for users who have opted out of motion at the OS level.
 *
 * Implementation notes:
 *  - We watch the media query, so changes during the session take effect.
 *  - We pause and clear `autoplay` so the browser does not auto-resume on
 *    visibility changes; we restore it if the user reverts the preference.
 *  - A MutationObserver picks up videos added later (e.g. by other scripts
 *    or section reloads in the theme editor).
 */
(() => {
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');

  const apply = (reduce) => {
    document.querySelectorAll('video').forEach((video) => {
      if (reduce) {
        if (video.autoplay) video.dataset.a11yMotionAutoplay = 'true';
        video.autoplay = false;
        if (!video.paused) video.pause();
      } else if (video.dataset.a11yMotionAutoplay === 'true') {
        video.autoplay = true;
        delete video.dataset.a11yMotionAutoplay;
        // Best-effort resume; ignored if blocked by browser policy.
        video.play?.().catch(() => {});
      }
    });
  };

  const init = () => {
    apply(mq.matches);

    if (mq.matches) {
      const observer = new MutationObserver(() => apply(true));
      observer.observe(document.body, { childList: true, subtree: true });
    }

    mq.addEventListener?.('change', (event) => apply(event.matches));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
